import { render, staticRenderFns } from "./videoDetail.vue?vue&type=template&id=0c8bb92d&scoped=true&"
import script from "./videoDetail.vue?vue&type=script&lang=js&"
export * from "./videoDetail.vue?vue&type=script&lang=js&"
import style0 from "./videoDetail.vue?vue&type=style&index=0&id=0c8bb92d&prod&lang=scss&scoped=true&"
import style1 from "./videoDetail.vue?vue&type=style&index=1&id=0c8bb92d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8bb92d",
  null
  
)

export default component.exports